import React, { useState, useRef } from 'react';

const AboutSection: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlayPause = (): void => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play().catch(error => {
          console.error('Error playing video:', error);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section id="about" className="py-12 md:py-20 px-6 md:px-12 bg-canvas-secondary">
      <div className="max-w-container mx-auto">
        <div className="flex flex-col md:flex-row-reverse gap-8 md:gap-12 items-center">
          <div className="relative group w-full md:w-[500px] flex-shrink-0">
            <video
              ref={videoRef}
              className="w-full h-auto rounded-xl"
              poster="https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
              controls
              playsInline
              preload="auto"
            >
              <source src="/videos/fashion-video.mp4" type="video/mp4" />
              Tu navegador no soporta el elemento de video.
            </video>
            {!isPlaying && (
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 flex items-center justify-center transition-all duration-300 rounded-xl pointer-events-none">
                <button
                  onClick={handlePlayPause}
                  className="w-16 h-16 rounded-full bg-white text-fg-highlight-primary flex items-center justify-center text-xl hover:scale-110 hover:bg-fg-highlight-primary hover:text-white transition-all duration-300 pl-1 pointer-events-auto"
                  aria-label="Reproducir video"
                >
                  ▶
                </button>
              </div>
            )}
          </div>
          <div className="text-center md:text-left">
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-fg-primary mb-4 md:mb-6 uppercase tracking-wider">
              Nosotros
            </h3>
            <div className="space-y-4 text-base md:text-lg leading-relaxed text-fg-secondary text-justify">
              <p>
                My Topped nace de un momento en el que la vida cambió todos los planes.
                Cuando entendí que empezar de nuevo no significa perderlo todo, sino descubrir una nueva versión de mí.
              </p>
              <p>
                Después de convertirme en mamá, tuve que replantear mis metas, mis tiempos y la forma en la que soñaba mi futuro. En medio de ese proceso nació My Topped: una marca de crop tops oversized creada para mujeres que siguen construyendo su camino, incluso cuando la ruta cambia.
              </p>
              <p>
                Creemos que la ropa también comunica lo que llevamos dentro. Por eso, cada colección está inspirada en la historia real de una mujer: su fuerza, sus aprendizajes, sus cambios y todo aquello que la hace única.
              </p>
              <p>
                No diseñamos solo prendas.<br />
                Diseñamos recordatorios de valentía, autenticidad y propósito.
              </p>
              <div>
                <h4 className="text-xl md:text-2xl font-semibold text-fg-primary mb-2 uppercase tracking-wider">
                  Lo que nos mueve
                </h4>
                <ul className="space-y-1">
                  <li>✨ Historias reales</li>
                  <li>✨ Diseños con significado</li>
                  <li>✨ Versatilidad para la vida real</li>
                  <li>✨ Mujeres que inspiran a otras mujeres</li>
                </ul>
              </div>
              <div>
                <h4 className="text-xl md:text-2xl font-semibold text-fg-primary mb-2 uppercase tracking-wider">
                  Más que una marca
                </h4>
                <p>
                  Queremos construir una comunidad donde vestir también sea conectar con ideas, emociones y versiones de nosotras mismas que merecen espacio.
                </p>
              </div>
              <p className="font-semibold text-fg-primary">
                My Topped<br />
                Moda con voz propia
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
